import { Viewport } from "../pixel-accessor";
import type { OutputViewportStrategy } from "./OutputViewportStrategy";
import type { ImageAdapter } from "../image-adapter";

/**
 * Uses clone of source image viewport as output image viewport.
 * Matches always.
 */
export class SourceImageViewport implements OutputViewportStrategy {
  /**
   * @inheritDoc
   */
  readonly priority = 3;

  /**
   * @inheritDoc
   */
  getOutputViewport(image: ImageAdapter<unknown>): Viewport {
    return image.getViewport().clone();
  }

  /**
   * @inheritDoc
   */
  match(): true {
    return true;
  }
}
